module.exports = __webpack_public_path__ + "img/lemsi-campus.69b897f6.svg";